import { useLingui } from "@lingui/react/macro";
import { PlanningFilterInput } from "./PlanningContextComponents";

export const PlanningPatientOrActivityTitleFilterInput = () => {
  const { t } = useLingui();
  return <PlanningFilterInput label={t`Sök patient/aktivitet`} />;
};
